import { render } from "./VehicleWithdrawalReasons.vue?vue&type=template&id=ced19fe8"
import script from "./VehicleWithdrawalReasons.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalReasons.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
